define("shared/utils/string-formatters/snake-to-camel", ["exports", "@ember/string"], function (_exports, _string) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/string"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */
  /**
   * @class snakeToCamel
   * @extends Utils
   */
  /** Returns a camel cased version of the given snake cased string
   *
   * @method snakeToCamel
   * @param {String} str Snake cased string
   *
   * @returns {String} Camel cased version of str
   * @protected
   */
  var _default = str => {
    if (typeof str !== 'string') {
      return str;
    }
    if (str.includes('_')) {
      return (0, _string.camelize)(str.toLowerCase());
    }
    return (0, _string.camelize)(str);
  };
  _exports.default = _default;
});